var render = function render(){var _vm=this,_c=_vm._self._c;return _c('twenty-four-hour',{attrs:{"id":_vm.id,"rule":_vm.rule}})
}
var staticRenderFns = []

export { render, staticRenderFns }